export default {"src":"/_next/static/media/bread.3f35f20c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};